import React from 'react';
import { Box } from '@mui/material';
import PreviewHeader from './PreviewHeader';
import AgentContactBar from './AgentContactBar';
import HighlightsSection from './HighlightsSection';
import PhotoGallery from './PhotoGallery';
import PreviewMap from './PreviewMap';
import FieldSection from './FieldSection';
import RemarksSection from './RemarksSection';
import PreviewFooter from './PreviewFooter';
import {
  useInternetSettings,
  useListingDetails,
  useOwnershipAgents,
  useAssociation,
  useTaxInfo,
  usePropertyDetails,
  useSizeRooms,
  useFeatures,
  useShowingInfo,
} from '../hooks';

const PreviewLayout: React.FC = () => {
  const internetSettings = useInternetSettings();
  const listingDetails = useListingDetails();
  const ownershipAgents = useOwnershipAgents();
  const association = useAssociation();
  const taxInfo = useTaxInfo();
  const propertyDetails = usePropertyDetails();
  const sizeRooms = useSizeRooms();
  const features = useFeatures();
  const showingInfo = useShowingInfo();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <PreviewHeader />
      <AgentContactBar />

      {/* Highlights */}
      <Box
        sx={{
          maxWidth: 1200,
          width: '100%',
          mx: 'auto',
          px: { xs: 2, md: 4 },
        }}
      >
        <HighlightsSection />
      </Box>

      {/* Gallery + Map row */}
      <Box
        sx={{
          maxWidth: 1200,
          width: '100%',
          mx: 'auto',
          px: { xs: 2, md: 4 },
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 3,
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ flex: '1 1 55%', minWidth: 0 }}>
          <PhotoGallery />
        </Box>
        <Box sx={{ flex: '1 1 45%', minWidth: 0 }}>
          <PreviewMap />
        </Box>
      </Box>

      {/* Field sections */}
      <Box
        sx={{
          maxWidth: 1200,
          width: '100%',
          mx: 'auto',
          px: { xs: 2, md: 4 },
          py: 4,
        }}
      >
        <FieldSection
          title="Internet & Listing Settings"
          fields={internetSettings}
        />
        <FieldSection title="Listing Details" fields={listingDetails} />
        <FieldSection title="Ownership & Agents" fields={ownershipAgents} />
        <FieldSection title="HOA / Association" fields={association} />
        <FieldSection title="Tax Information" fields={taxInfo} />
        <FieldSection title="Property Details" fields={propertyDetails} />
        <FieldSection title="Size & Rooms" fields={sizeRooms} />
        <FieldSection title="Features & Amenities" fields={features} />
        <FieldSection title="Showing Information" fields={showingInfo} />
        <RemarksSection />
      </Box>

      <PreviewFooter />
    </Box>
  );
};

export default PreviewLayout;
